<template>
<tr>
    <td>
        <input v-if="editing" class="form-control" v-model="form.name" required>
        <span v-else>{{ role.name }}</span>
    </td>

    <td>
        <input v-if="editing" class="form-control" v-model="form.access_level" type="number" required>
        <span v-else>{{ role.access_level }}</span>
    </td>

    <td>
        <template v-if="!editing">
            <span v-for="permission in role.permissions">{{ permission.name }}<br></span>
        </template>

        <div v-else v-for="(grouped_permissions, key) in permissions" class="mb-2">
            <div class="text-blue-700 font-weight-bold">{{ key }}</div>            
            <div class="form-check" v-for="permission in grouped_permissions">
                <input type="checkbox" class="form-check-input" :value="permission.id" v-model="form.permissions">
                <label class="form-check-label">{{ permission.name }}</label>
            </div>
        </div>
    </td>

    <td>
        <span v-if="!editing" class="btn btn-outline-primary" @click="startEditing()">Edit</span>
        <template v-else>
            <span class="btn btn-ghost-danger" @click="deleteRole()">Delete</span>
            <span class="btn btn-outline-secondary" @click="stopEditing()">Cancel</span>
            <span class="btn btn-outline-primary" @click="saveRole()">Save</span>
        </template>
    </td>
</tr>
</template>

<script>
    export default {
        props: ['role', 'permissions'],

        data() {
            return {
                editing: false,
                form: {},
            }
        },

        methods: {
            deleteRole() {
                this.$emit('delete_role', this.role.id);
            },

            saveRole() {
                axios.put('/api/roles/' + this.role.id, this.form).then(data => {
                    this.$emit('role_saved');
                    this.editing = false;
                });
            },

            startEditing() {
                this.form = {
                    name: this.role.name,
                    access_level: this.role.access_level,
                    permissions: this.role.permissions.map(perm => perm.id),
                }
                this.editing = true;
            },

            stopEditing() {
                this.editing = false;
            }
        }
    }
</script>